export const NAMESPACE = 'conflicts_listing';
export const STRATEGY = {
    ACCEPT_FROM_TECHNICIAN: 'accept_from_technician',
    KEEP_MOST_COMPLETE: 'keep_most_complete'
};
